/* eslint-disable no-underscore-dangle */
import { client as elevioClient } from 'elevio'

import { Auth0User, Roles } from '../types'
import { userHasRole } from './authenticationUtils'

type ElevioUser = {
  /** Email associated with the user
   * Note: we don't currently pass along an email as it would require a round-trip to the API.
   * See Hash prop for more details.
   */
  email?: string
  /** First name of the user according to Auth0 */
  first_name?: string | null
  /** Smart groups associated with the user's roles */
  groups: string[]
  /** Hmac hash generated using elevio secret key. Required in order to pass along an email.
   * https://api-docs.elevio.help/en/articles/24-setuser
   */
  hash?: string
  /** Last name of the user according to Auth0 */
  last_name?: string | null
}

export default function loadElevioClient(auth0User: Auth0User) {
  // load elevio + provide user
  const elevioAccountId = process.env.REACT_APP_ELEVIO_ID

  if (!elevioAccountId) {
    return
  }

  elevioClient.load(elevioAccountId).then(() => {
    const elevioGroups = []
    if (userHasRole(auth0User, [Roles.student])) {
      elevioGroups.push('se-student')
    }
    if (userHasRole(auth0User, [Roles.admin]) || userHasRole(auth0User, [Roles.civitasEmployee])) {
      elevioGroups.push('se-admin')
    }
    const user: ElevioUser = {
      first_name: auth0User.firstName,
      last_name: auth0User.lastName,
      groups: elevioGroups
    }

    window._elev.setUser(user)
  })
}
